import BigContainer from '@/components/layout/containers/BigContainer'
import PageWrap from '@/components/layout/containers/PageWrap'
import { Helmet } from 'react-helmet-async'

function PageNotFound() {
  return (
    <PageWrap>
      <Helmet>
        <title>Not Found</title>
      </Helmet>
      <BigContainer>
        <div className="mt-20 -mb-10 flex flex-col items-center justify-center">
          <h1 className="text-8xl font-black">404</h1>
          <h2 className="mb-3 text-2xl font-bold">{'Page Not Found :('}</h2>
        </div>
      </BigContainer>
    </PageWrap>
  )
}

export default PageNotFound
